import React from 'react';

import { Button, QuantityInput, useAccordionContext } from '@hpi-sox/hpstellar-core';
import { Cross, Minus, ChevronRight } from '@hpi-sox/hpstellar-icons';

import Facet from './vwa-facet';
import './range-input.less';
import {
    formatMetricValue,
    memoizedFormatMetricValue,
    PRICE_GTM_ID,
    getPriceFacetsGtmActions,
} from '../../metrics/metrics-helpers';
import { getInputProps } from '../util';

export default ({
    setRange,
    onSelectPresetRange,
    clearRange,
    priceFacets,
    range,
    onSubmitRange,
    presetRange,
    rangeEmpty,
}) => {
    const values = useAccordionContext();
    const { expanded } = values || {};

    const preventFocusProp = {
        tabIndex: -1,
    };

    return (
        <>
            <div className="priceRange">
                {/* TODO: input validation */}
                <QuantityInput
                    className="input"
                    onChange={e => setRange([parseInt(e.target.value), range[1]])}
                    symbol="$"
                    symbolPosition="left"
                    type="number"
                    min="0"
                    step="1"
                    value={range[0]}
                    {...getInputProps(expanded, 'Min', 'Minimum price', preventFocusProp)}
                />
                <span className="divider">
                    <Minus size="s" />
                </span>
                <QuantityInput
                    className="input"
                    onChange={e => setRange([range[0], parseInt(e.target.value)])}
                    symbol="$"
                    symbolPosition="left"
                    type="number"
                    min="0"
                    step="1"
                    value={range[1]}
                    {...getInputProps(expanded, 'Max', 'Maximum price', preventFocusProp)}
                />
                <button
                    className="button"
                    onClick={onSubmitRange}
                    type="button"
                    data-gtm-id={PRICE_GTM_ID}
                    data-gtm-value={formatMetricValue(range.join('-'), ['$'])}
                    data-gtm-category="facet"
                    data-gtm-checked
                    aria-label={`Apply price filter from ${range[0]} to ${range[1]}`}
                    {...(!expanded ? preventFocusProp : {})}
                >
                    <ChevronRight size="s" color="white" />
                </button>
            </div>
            {!rangeEmpty && (
                <div className="clearButton">
                    <Button
                        variation="tertiary"
                        endIcon={<Cross size="xs" />}
                        onClick={clearRange}
                        {...(!expanded ? preventFocusProp : {})}
                    >
                        CLEAR PRICE RANGE
                    </Button>
                </div>
            )}
            <div className="presetRange">
                {priceFacets &&
                    priceFacets.map((preset, i) => (
                        <Facet
                            key={`preset-range-${i}`}
                            label={preset.label}
                            checked={presetRange.includes(i)}
                            onChange={() => onSelectPresetRange(preset.value, i)}
                            aligned="left"
                            gtmActions={getPriceFacetsGtmActions(
                                preset.gtmActions,
                                preset.label,
                                Array.isArray(presetRange) ? !presetRange.includes(i) : true,
                            )}
                        />
                    ))}
            </div>
        </>
    );
};
